<section class="analogue-group-select">
  <div class="analogue-group-select__header">
    <div>
      <h2>Выберите группу аналогов</h2>
      <p>
        {{ data.providerName }}<span *ngIf="data.contractNumber"> · {{ data.contractNumber }}</span>
      </p>
    </div>

    <button mat-icon-button type="button" (click)="close()" aria-label="Закрыть">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="analogue-group-select__note">
    <p>
      Поставщик не позволил автоматически определить нужную группу для загрузки аналогов.
    </p>
    <p *ngIf="data.productTitle">Текущий товар: {{ data.productTitle }}</p>
    <p *ngIf="data.lookupArticle">Артикул поиска: {{ data.lookupArticle }}</p>
    <p>Выбор применяется только к этой загрузке.</p>
  </div>

  <div class="analogue-group-select__options">
    <button
      type="button"
      class="analogue-group-select__option"
      *ngFor="let subGroupCode of data.availableSubGroupCodes"
      [class.analogue-group-select__option--active]="selectedSubGroupCode === subGroupCode"
      (click)="select(subGroupCode)"
    >
      <span class="analogue-group-select__option-title">{{ subGroupCode }}</span>
      <mat-icon *ngIf="selectedSubGroupCode === subGroupCode">check_circle</mat-icon>
    </button>
  </div>

  <div class="analogue-group-select__actions">
    <button mat-stroked-button type="button" (click)="close()">Отмена</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!selectedSubGroupCode" (click)="confirm()">
      Загрузить
    </button>
  </div>
</section>
